import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class TAGLAMINA extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">TAG LAMINA</h1>
        </header>

        {/* English Section */}
        <div className="section">
          <h3>English</h3>
          <ul>
            <li><span className="label">1. Gazette Notification number and Date:</span> S.O.2346 (E) Dated 26-05-2025</li>
            <li><span className="label">2. Title of Biostimulant:</span> (6) Kappaphycus alvarezii 7.2% (Liquid)</li>
            <li><span className="label">3. Composition:</span>
              <ul>
                <li>(i) Kappaphycus alvarezii extract per cent. by weight, minimum: 7.2</li>
                <li>(ii) Organic acids (Acetic, Citric and Lactic acid) per cent. by weight, minimum: 0.8%</li>
                <li>(iii) Water per cent. by weight: 92.0%</li>
                <li>(iv) Total (per cent): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. Crop:</span> Cucumber</li>
            <li><span className="label">5. Doses:</span>
              <ul>
                <li>Cucumber: Three foliar sprays at 1.25 l/ha</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Hindi Section */}
        <div className="section">
          <h3>हिन्दी</h3>
          <ul>
            <li><span className="label">1. राजपत्र अधिसूचना संख्या एवं दिनांक:</span> एस.ओ.2292 (ई) दिनांक 26-05-2025</li>
            <li><span className="label">2. जैवउत्तेजक का नाम:</span> (6) कप्पाफाइकस अल्वारेज़ी 7.2% (तरल)</li>
            <li><span className="label">3. संरचना:</span>
              <ul>
                <li>(i) कप्पाफाइकस अल्वारेज़ी अर्क, भार के अनुसार न्यूनतम प्रतिशत: 7.2</li>
                <li>(ii) कार्बनिक अम्ल (एसिटिक, साइट्रिक और लैक्टिक अम्ल) भार के अनुसार न्यूनतम प्रतिशत: 0.8%</li>
                <li>(iii) जल, भार के अनुसार न्यूनतम प्रतिशत: 92.0%</li>
                <li>(iv) कुल (प्रतिशत): 100.0</li>
              </ul>
            </li>
            <li><span className="label">4. फसल:</span> खीरा</li>
            <li><span className="label">5. मात्रा:</span>
              <ul>
                <li>खीरा: 1.25 लीटर/हेक्टेयर की दर से तीन पर्णीय छिड़काव</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Marathi Section */}
        <div className="section">
          <h3>मराठी</h3>
          <ul>
            <li><span className="label">१. राजपत्र अधिसूचना क्रमांक आणि तारीख:</span> S.O.2292 (E) दिनांक २६-०५-२०२५</li>
            <li><span className="label">२. बायोस्टिम्युलंटचे शीर्षक:</span> (६) कप्पाफायकस अल्वारेझी ७.२% (द्रव)</li>
            <li><span className="label">३. रचना:</span>
              <ul>
                <li>(i) कप्पाफायकस अल्वारेझी अर्क प्रति टक्के. वजनाने, किमान: ७.२</li>
                <li>(ii) सेंद्रिय आम्ल (अॅपसिटिक, सायट्रिक आणि लॅक्टिक आम्ल) प्रति टक्के. वजनाने, किमान: ०.८%</li>
                <li>(iii) पाणी प्रति टक्के. वजनाने: ९२.०%</li>
                <li>(iv) एकूण (टक्के): १००.०</li>
              </ul>
            </li>
            <li><span className="label">४. पीक:</span> काकडी</li>
            <li><span className="label">५. डोस:</span>
              <ul>
                <li>काकडी: १.२५ लिटर/हेक्टर या दराने तीन पानांवरील फवारण्या</li>
              </ul>
            </li>
          </ul>
        </div>

      </div>
    )
  }
}
